import styled from 'styled-components';

import { LinkButton } from '#/components/LinkButton';
import { Markdown } from '#/components/Markdown';
import { cssPlanContainerBase } from '#/plugins/paywall/components';
import { remify } from '#/service/utils';

export const ReceiptButton = styled(LinkButton)`
  font: var(--fontStyleCallout);

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Receipt = styled.div`
  ${cssPlanContainerBase};
  margin-bottom: ${remify(24)};
`;

export const ReceiptLineBreak = styled.div`
  opacity: 0.12;
  margin: ${remify(16)} 0 ${remify(15)};
  width: 100%;
  height: 1px;
  background: var(--pageHeadingForeground);
`;

export const PaymentFormFooter = styled(Markdown)`
  font: var(--fontStyleCaption1);
  color: var(--pageParagraphForeground);
  text-align: center;
`;

export const PriceText = styled.span`
  font: var(--fontStyleTitle);
`;
